function descendingComparator(a, b, orderBy) {
    const splittedFieldName = orderBy.toString().split(".");
    const valueOf = (obj) =>
        splittedFieldName && Array.isArray(splittedFieldName)
            ? splittedFieldName.reduce((val, objName) => (val ? val[objName] : null), obj)
            : obj[orderBy];
    if (valueOf(b) < valueOf(a)) {
        return -1;
    }
    if (valueOf(b) > valueOf(a)) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, order, orderBy) {
    const comparator = getComparator(order, orderBy);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
